import axios from "axios";
import { v4, validate } from "uuid";

const rawUuid = import.meta.env.VITE_N8N_UUID_PATH_BANKING;
export const N8N_UUID_PATH_BANKING = validate(rawUuid) ? rawUuid : null;

export function getAPIN8N(uuid?: string, isLedgerUrl: boolean = false) {
  const token = localStorage.getItem("barte-auth-token");

  let baseURL = isLedgerUrl ? import.meta.env.VITE_N8N_LEGDER_API_URL : import.meta.env.VITE_N8N_API_URL;

  if (uuid) {
    if(baseURL.includes("/hml/")) {
      baseURL = baseURL.replace("/hml/", `/${uuid}/hml/`);
    } else if (baseURL.includes("/prd/")) {
      baseURL = baseURL.replace("/prd/", `/${uuid}/prd/`);
    } else if (baseURL.includes("/webhook/")) {
      baseURL = baseURL.replace("/webhook/", `/webhook/${uuid}/`);
    }
  }
  const n8nApi = axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${token}`,
      "X-Token-Api": import.meta.env.VITE_N8N_TOKEN_API,
      "X-Idempotency-Key": v4(),
      "Content-Type": "application/json",
    },
  });

  return n8nApi;
}
